var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#008CFF",
    strokeLinejoin: "round",
    d: "M20.7 10.54v1.908c0 .636-.516 1.152-1.152 1.152H3.452A1.152 1.152 0 012.3 12.448V10.54a2.041 2.041 0 100-4.08V4.552c0-.636.516-1.152 1.152-1.152h16.096c.636 0 1.152.516 1.152 1.152V6.46a2.041 2.041 0 100 4.08zM6.9 6.8h4.6m-4.6 3.4h9.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EDF7FF",
    strokeWidth: 1.15,
    d: "M.575 16.433L21.275.567"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#008CFF",
    d: "M1.725 16.433L22.425.567"
  }))));
}
export default SvgCancelBooking;